import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Offcanvas } from "react-bootstrap";
import Common_Back_Btn from "../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Loading_Lottie from "../../../animation/loading_lottie/Loading_Lottie";
import Gray_Btn from "../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import "./Common_Report_Offcanvas.css";

const Common_Report_Offcanvas = ({ show, handleClose, setSuccess, title }) => {
  const [showLottie, setShowLottie] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowLottie(false);
    }, 3000);
  }, []);

  const onSubmit = async (data) => {
    handleClose();
    setSuccess(true);

     setTimeout(() => {
    setSuccess(false);
    handleClose();
  }, 3000);
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Common_Report_Offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          {title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="main_content_div">
          {showLottie ? (
            <div className="lottie_div">
              <Loading_Lottie />
            </div>
          ) : (
            <div className="report_div">
              <div className="exl_img_holder">
                <img src="/assets/images/other/xlsx.png" className="xl_img" />
              </div>

              <div className="report_footer">
                <p className="inner_text">
                  Your Report Has Been Successfully Generated. You Can Now
                  Download Or Share It.
                </p>

                <Black_Submit_Btn btnText={"Download Report"} />
                <Gray_Btn btnText={"Share Report"} />
                
              </div>
            </div>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Common_Report_Offcanvas;
